import { DEBUG } from './debug';
import { ICollidable, Bounds } from './collision/types';
import { Cat } from './cat';

export class Tree implements ICollidable {
	x: number;
	y: number;
	groundY: number;
	width: number;
	height: number;
	readonly collisionType = 'tree';

	constructor(x: number, groundY: number) {
		this.x = x;
		this.groundY = groundY;
		this.height = 200;
		this.y = groundY - this.height;
		this.width = 32;
	}

	getBounds(): Bounds {
		return {
			x: this.x,
			y: this.y,
			width: this.width,
			height: this.height,
		};
	}

	isActive(): boolean {
		return true;
	}

	onCollision(other: ICollidable): void {
		if (other instanceof Cat) {
			other.handleTreeCollision(this);
		}
	}

	draw(): void {
		noStroke();
		fill(120, 100, 40);
		rect(this.x, this.y, this.width, this.height);

		// Yaprakları gövdenin üstüne yerleştir
		const leavesY = this.y;
		fill(0, 120, 0);
		triangle(this.x - 30, leavesY + 40, this.x + 20, leavesY - 40, this.x + 70, leavesY + 40);
		fill(0, 140, 0);
		triangle(this.x - 20, leavesY + 30, this.x + 20, leavesY - 50, this.x + 60, leavesY + 30);
		fill(0, 160, 0);
		triangle(this.x - 10, leavesY + 20, this.x + 20, leavesY - 70, this.x + 50, leavesY + 20);

		// Collision detection alanını göster (debug) - sadece gövde
		if (DEBUG.COLLISION) {
			noFill();
			stroke(255, 0, 0);
			strokeWeight(2);
			rect(this.x, this.y, this.width, this.height);
		}
	}
}
